module.exports = __webpack_public_path__ + "img/F75701CD.1c6b43a7.png";